import * as actionTypes from "../actionTypes";

export const saveDailyData = (data) => {
  return {
    type: actionTypes.SAVE_DAILY_DATA,
    payload: data,
  };
};

export const savePhoneNumber = (data) => {
  return {
    type: actionTypes.SAVE_PHONE_NUMBER,
    payload: data,
  };
};

export const saveEmployeeName = (data) => {
  return {
    type: actionTypes.SAVE_EMPLOYEE_NAME,
    payload: data,
  };
};

export const saveOutletName = (data) => {
  return {
    type: actionTypes.SAVE_OUTLET_NAME,
    payload: data,
  };
};
